<template>
  <div class="content md flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-video"
      entity-name="视频"
      add-btn="添加直播视频"
      hide-show-detail
      :hide-action="!editable"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :deal-list="dealList"
      :modalWidth="modalWidth"
      :searchKeyType="searchKeyType"
    >
      <template v-slot:query="{ form }">
        <a-form-model-item label="">
          <a-input
            v-model="form.detail"
            placeholder="输入直播视频标题查询"
          ></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{ form }">
        <a-form-model-item label="类型" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="1">直播</a-radio>
            <a-radio :value="2">视频</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="标题"></a-input>
        </a-form-model-item>
        <template v-if="form.type == 1">
          <a-form-model-item label="直播地址" prop="url">
            <a-input
              v-model="form.url"
              placeholder="请输入HLS播放地址"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="录像地址" prop="record">
            <a-input
              v-model="form.record"
              placeholder="请输入直播录像HLS播放地址"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item label="开始时间" prop="start">
            <a-date-picker
              show-time
              value-format="yyyy-MM-DD HH:mm:ss"
              v-model="form.start"
              placeholder="选择直播开始时间"
            >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="结束时间" prop="end">
            <a-date-picker
              show-time
              value-format="yyyy-MM-DD HH:mm:ss"
              v-model="form.end"
              placeholder="请选择直播结束时间"
            >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="直播封面" prop="cover">
            <cl-upload v-model="form.cover"></cl-upload>
          </a-form-model-item>
        </template>
        <template v-else-if="form.type == 2">
          <a-form-model-item label="上传视频" prop="src">
            <cl-upload type="video" v-model="form.src"></cl-upload>
          </a-form-model-item>
          <a-form-model-item label="视频封面" prop="cover">
            <cl-upload v-model="form.cover"></cl-upload>
          </a-form-model-item>
        </template>
        <a-form-model-item label="简介">
          <rich-editor v-model="form.desc"></rich-editor>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>
import clUpload from "../../../components/cl-upload.vue";
import mixins from "../mixins";

export default {
  name: "ActivityVideo",
  components: {
    clUpload,
  },
  data() {
    return {
      modalWidth: 600,
      searchKeyType: {
        detail: 1,
      },
      moduleKey: 'furnish-video',
      columns: [
        { title: "标题", dataIndex: "title" },
        {
          title: "封面",
          dataIndex: "cover",
          customRender: (text) => {
            return <img class="avatar" src={text} />;
          },
        },
        {
          title: "类型",
          dataIndex: "type",
          customRender: (text) => {
            return <span>{text == 1 ? "直播" : "视频"}</span>;
          },
        },
      ],
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        url: [{ required: true, message: "请输入直播地址", trigger: "blur" }],
        record: [
          {
            required: true,
            message: "请输入直播录像播放地址",
            trigger: "blur",
          },
        ],
        start: [
          { required: true, message: "请选择直播开始时间", trigger: "change" },
        ],
        end: [
          { required: true, message: "请输入直播结束时间", trigger: "change" },
        ],
        src: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请上传视频"));
              }
            },
            trigger: "change",
          },
        ],
        cover: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请上传封面图"));
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  mixins: [mixins],
  computed: {
    action() {
      return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
    },
    activity() {
      return this.$store.getters.activity;
    },
    query() {
      let res = "";
      const activity = this.activity;
      if (activity) {
        res += `&filter[activity_id]=${activity.id}`;
      }
      return res;
    },
  },
  methods: {
    beforeUpdate(form, callback) {
      let data = {
        type: form.type,
      };
      //添加视频将活动ID插进去
      if (!form.id) {
        data.activity_id = this.activity.id;
      } else {
        data.id = form.id;
        data.activity_id = form.activity_id;
      }
      if (form.type == 1) {
        data.detail = JSON.stringify({
          title: form.title,
          url: form.url,
          record: form.record,
          start: form.start,
          end: form.end,
          cover: form.cover,
          desc: form.desc,
        });
      } else if (form.type == 2) {
        data.detail = JSON.stringify({
          title: form.title,
          src: form.src,
          cover: form.cover,
          desc: form.desc,
        });
      }
      callback(data);
    },
    dealList(list, callback) {
      list = list.map((item) => {
        try {
          let temp = JSON.parse(item.detail);
          item = Object.assign(item, temp);
          return item;
        } catch (e) {
          console.error(e);
        }
      });
      callback(list);
    },
  },
};
</script>

<style scoped></style>
